import React, { useEffect, useState } from 'react'
import useConfigureAndSendTag from '../analytics/useConfigureAndSendTag'
import s from './MenuCategoriesGE.less'
import { useSelector } from 'react-redux'
import { loadPoiAssetsConfiguration } from '../../store/poiassets/poiassets.actions'
import { selectCategoriesMenu } from '../../store/poiassets/poiassets.selectors'
import MenuSubCategoriesGE from './MenuSubCategoriesGE'
import MenuCategoryItem from './MenuCategoryItem'
import { withEmptyFallbackErrorBoundary } from '../error/EmptyFallbackErrorBoundary'
import { withFrenchSite } from '../i18n/i18nSite'
import { withOnlyGE } from '../Device'
import { useAction } from '../utils/react-redux'
import { TAG_CLICK_CATEGORY_BAR } from '../analytics/analytics.tagids.constants'
import { APP_OR_SUBCAT_ID, CAT_ID } from '../analytics/ClickTagsService'
import { navigateToSearchByCategory, navigateToPoisOnRouteByCategory } from '../../store/history/history.actions'
import useTimeout from '../utils/useTimeout'

import classNames from 'classnames'
import AutoPromoOpenButton from '../autopromo/AutoPromoOpenButton'
import analyticsConstants from '../analytics/analytics.constants'
import { selectIsPageElligibleForPoisOnRoute } from '../../store/history/history.selectors'

export const MenuCategoriesGE = () => {
  const [categoryId, setCategoryId] = useState()
  const execLoadPoiAssetsConfiguration = useAction(loadPoiAssetsConfiguration)
  const execNavigateToSmrByCategory = useAction(navigateToPoisOnRouteByCategory)

  useEffect(() => {
    execLoadPoiAssetsConfiguration()
  }, [execLoadPoiAssetsConfiguration])

  const categories = useSelector(selectCategoriesMenu)
  const isPageElligibleForPoisOnRoute = useSelector(selectIsPageElligibleForPoisOnRoute)
  const [setMouseOverTimeout, clearMouseOverTimeout] = useTimeout(100)

  const onMouseOver = categoryId => () => setCategoryId(categoryId)

  const onMouseOut = () => setMouseOverTimeout(unselectCategory)

  const unselectCategory = () => setCategoryId(null)

  const onMenuMouseOver = () => clearMouseOverTimeout()

  const onMenuMouseOut = () => setMouseOverTimeout(unselectCategory)

  const configureAndSendTag = useConfigureAndSendTag()
  const execNavigateToSearchByCategory = useAction(navigateToSearchByCategory)

  const onCategoryClick = catId => e => {
    configureAndSendTag({
      type: TAG_CLICK_CATEGORY_BAR,
      tagInfo: {
        [CAT_ID]: catId,
        [APP_OR_SUBCAT_ID]: 'all'
      }
    })

    if (isPageElligibleForPoisOnRoute) {
      execNavigateToSmrByCategory(catId)
    } else {
      execNavigateToSearchByCategory(catId)
    }
    unselectCategory()
  }
  return categories?.length ? (
    <div
      className={categoryId ? classNames(s.container, s.borderless) : s.container}
      onMouseOver={onMenuMouseOver}
      onMouseOut={onMenuMouseOut}
    >
      <ul className={s.categories}>
        {categories.map(({ id, shortLabel, iconId, color }) => (
          <MenuCategoryItem
            key={`category-${id}`}
            id={id}
            shortLabel={shortLabel}
            iconId={iconId}
            color={color}
            selected={categoryId === id}
            active={!categoryId}
            onMouseOver={onMouseOver(id)}
            onCategoryClick={onCategoryClick(id)}
          />
        ))}
      </ul>
      {categoryId && <MenuSubCategoriesGE categoryId={categoryId} onMouseLeaveMenu={onMouseOut} />}
      <div className={s.autoPromoButton}>
        <AutoPromoOpenButton area={analyticsConstants.autopromo.area.header} />
      </div>
    </div>
  ) : null
}

export default withEmptyFallbackErrorBoundary(withFrenchSite(withOnlyGE(MenuCategoriesGE)))
